export default "__VITE_ASSET__a3c65abf__"